// import Button from '../../components/Buttom/Button'; // Descomentar junto com o botão abaixo
import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './styles';
import IExperience from 'interfaces/IExperience';
import SubTitle from 'common/SubTitle/SubTitle';

interface Props {
  experiences?: IExperience[];
}

const Tourism = (props: Props): JSX.Element => {
  const { experiences } = props;

  return (
    <Container>
      <SubTitle text="Experiências Turísticas" />
      <ul>
        {experiences?.slice(0, 12).map(experience => {
          return (
            <Link
              key={experience.id}
              to={`/what-to-do/activities?experience=${encodeURIComponent(experience.title)}`}
              style={{ textDecoration: 'none', color: 'inherit' }}>
              <li>
                <img src={experience.image} alt={experience.title} />
                <span>{experience.title}</span>
              </li>
            </Link>
          );
        })}
      </ul>
      {/*
      <Link to="/what-to-do/activities">
        <Button text="VER TODAS AS EXPERIÊNCIAS" />
      </Link>
      */}
    </Container>
  );
};

export default Tourism;
